import { getConfig } from '@constants';

import { EBrowserFamily } from '@enums';

export function isIeBrowser(): boolean {
	return getConfig().browserFamily === EBrowserFamily.IE;
}
